import { render, staticRenderFns } from "./student-upload-fail-list.vue?vue&type=template&id=2263d861&scoped=true"
import script from "./student-upload-fail-list.vue?vue&type=script&lang=js"
export * from "./student-upload-fail-list.vue?vue&type=script&lang=js"
import style0 from "./student-upload-fail-list.vue?vue&type=style&index=0&id=2263d861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263d861",
  null
  
)

export default component.exports